import { useParams } from 'react-router-dom';
import { useProgramPageRedirect } from '@pages/programs/program-page/helpres.ts';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { useProgramQuery } from '@src/api/api-hooks/programs/useProgramQuery.ts';
import VideoProgram from 'library/components/programs/VideoProgram';

export const ProgramPage: React.FC = () => {
  const { id } = useParams<{ id: string; code: string }>();
  const { code } = useModuleByCodeParam();
  const {
    doRedirectOnPrevPage,
    // prevPageUrl
  } = useProgramPageRedirect();
  const {
    // isLoading, isFetching,
    data: program,
    isError,
  } = useProgramQuery({ id });

  // if (isLoading || isFetching) {
  //   return <Loader />;
  // }

  if (isError) {
    return 'Error';
  }
  // console.log('prevPageUrl:', prevPageUrl);
  return (
    <VideoProgram
      program={program}
      onClose={() => doRedirectOnPrevPage(`/programs/${code}`)}
      key={program?.pk}
    />
  );
};
